import type { ColorBackgroundAlias } from '@shopify/polaris-tokens';
import type { RangeSliderProps } from '@shopify/polaris';

import { RangeSlider } from '@shopify/polaris';
export interface GRangeSliderProps extends RangeSliderProps {
  boxId?: string;
  backgroundLower?: ColorBackgroundAlias | string;
  backgroundUpper?: ColorBackgroundAlias | string;
}
export const GRangeSlider = ({ backgroundLower, backgroundUpper, ...props }: GRangeSliderProps) => {
  const style = {
    '--gp-single-thumb-progress-lower': backgroundLower, // `var(--p-color-${backgroundLower})`,
    '--gp-single-thumb-progress-upper': backgroundUpper, // `var(--p-color-${backgroundUpper})`,
  } as React.CSSProperties;

  return (
    <div className="Polaris-GRangeSlider" style={style}>
      <RangeSlider {...props} />
    </div>
  );
};
